/* eslint-disable react/no-array-index-key */

import { Radio } from '@mui/material';
import { ShipmentStatus } from '@constants';
import { useNavigate } from 'react-router-dom';
import { SplitLine, Tag } from '../common';
import { Merchandise } from '../merchandise';
import classes from './index.module.css';
import { RemarkPanel } from './remark-panel';
import { WrongInfo } from '../wongInfo';

const HAS_CLAIME_TEXT = 'This item already has a reported issue.';

export const RadioItem = ({
  item,
  handleChange,
  index,
  packageIndex,
  disabled = false,
  selectedItems = [], handleEdit,
}) => {
  const navigate = useNavigate();
  const {
    claimId, comment, attachments = [],
  } = item;

  const handleItemClick = (item) => {
    navigate(`../feedback?claimId=${item.claimId}`);
  };

  return (
    <div key={`${item.lineItemId}_${packageIndex}_${index}`}>
      {index === 0 ? null : <SplitLine />}
      <section id="responsive_line_item" className={classes.check_box_item}>
        <Radio
          id="responsive_line_item_checkbox"
          color="input"
          onChange={(e) => handleChange(e, packageIndex, index, item)}
          disabled={disabled}
          value={`${item.lineItemId}__${packageIndex}__${index}`}
          checked={selectedItems?.includes(`${item.lineItemId}__${packageIndex}__${index}`)}
        />
        <Merchandise item={item} className={classes.check_merchandise} />
      </section>
      {/* 是否已经申请过 */}
      {claimId
        ? (
          <RemarkPanel
            title={HAS_CLAIME_TEXT}
            btnText="View issue &gt; "
            isShow={false}
            onClick={() => handleItemClick(item)}
          />
        )

        : null}
      {/* 未申请且选择了原因 */}
      {(!claimId && !!attachments.length) ? (
        <section className={classes.remark}>
          <section className={classes.remark_header}>
            <section>
              {!!attachments.length && (
                <section className={classes.photos}>
                  <span className={classes.bold}>Photos:&nbsp;</span>
                  <span style={{ wordBreak: 'break-word' }}>{attachments.map((item) => item.originalFileName).join('; ')}</span>
                </section>
              )}
              {!!comment && (
                <section className={classes.additional}>
                  <span className={classes.bold}>Additional comments: </span>
                  {comment}
                </section>
              )}
            </section>
            <section className={classes.remark_link} onClick={() => handleEdit(item, packageIndex, index)}>Edit</section>
          </section>

        </section>
      ) : null}
      <div style={{ height: '1px' }}></div>
    </div>
  );
};

export const PackageRadioGroup = ({
  packageItem,
  packageIndex,
  onChange,
  selectedItems,
  handleItemEdit,
  reasonList,
  undeliveredAbled,
}) => {
  if (!packageItem) {
    return null;
  }
  const { items, status, fulfillmentName } = packageItem;
  const isDelivered = status === ShipmentStatus.Delivered;
  return (
    <>
      {packageIndex === 0 ? null : <SplitLine />}
      {fulfillmentName ? (
        <section className={classes.radio_line}>
          <span className={classes.order_name}>
            <span className={classes.order_name_title}>Order</span>
            {fulfillmentName}
          </span>
          <Tag
            color={isDelivered ? '#AEE9D1' : '#E4E5E7'}
            text={isDelivered ? 'Delivered' : 'Undelivered'}
          />
          {
            !isDelivered ? (
              <WrongInfo name={fulfillmentName} status={status} />
            ) : null
          }
        </section>
      ) : null}
      {items.map((item, index) => (
        <RadioItem
          key={item.lineItemId + index}
          item={item}
          handleChange={onChange}
          index={index}
          selectedItems={selectedItems}
          packageIndex={packageIndex}
          disabled={!!item.claimId || (!undeliveredAbled && !isDelivered)}
          handleEdit={handleItemEdit}
          reasonList={reasonList}
        />
      ))}
    </>
  );
};
